import { userConstants } from "../_constants";

let isAlreadyLoggedIn =
  JSON.parse(localStorage.getItem("main-login")) ||
  process.env.NODE_ENV === "production";
const initialState = { mainLogin: isAlreadyLoggedIn ? true : false };

export function mainlogin(state = initialState, action) {
  switch (action.type) {
    case userConstants.MAIN_LOGIN_SUCCESS:
      return { mainLogin: true };
    case userConstants.MAIN_LOGIN_FAILURE:
      return { mainLogin: false };
    default:
      return state;
  }
}
